// extracted by mini-css-extract-plugin
module.exports = {"forgot":"Login_forgot__3yg8G","googleSingIn":"Login_googleSingIn__c1VK_"};